// Copilot onboarding bubble (SPEC 001 T145)
// Auto-dismiss after 8s, click-to-dismiss.
import React, { useEffect } from "react";
import { MdAutoAwesome } from "react-icons/md";

interface CopilotOnboardingBubbleProps {
  onDismiss: () => void;
}

const CopilotOnboardingBubble: React.FC<CopilotOnboardingBubbleProps> = ({
  onDismiss,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss();
    }, 8000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      onClick={onDismiss}
      className="dv-ring-gradient animate-fade-up absolute bottom-16 right-0 w-64 cursor-pointer rounded-2xl bg-white p-3.5 nina-surface shadow-dv-lg dark:bg-navy-800"
      role="status"
      aria-live="polite"
    >
      <div className="mb-1.5 flex items-center gap-2">
        <span className="dv-animated-gradient animate-dv-pulse-glow flex h-7 w-7 items-center justify-center rounded-xl bg-[length:200%_200%] text-white shadow-dv-glow">
          <MdAutoAwesome className="h-4 w-4" aria-hidden="true" />
        </span>
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          Olá, sou a <span className="dv-gradient-text">NINA</span>
        </p>
      </div>
      <p className="text-xs text-gray-600 dark:text-gray-300">
        Pergunte sobre projetos, faturamento e horas — eu resumo e ajo por você.
        Clique aqui para começar.
      </p>
    </div>
  );
};

export default CopilotOnboardingBubble;
